module.exports = __webpack_public_path__ + "img/heartsArrows-2@2x.ddb1373.png";